import {
	AmendmentsAndCancellationsZendeskFormProductionConfig,
	AmendmentsAndCancellationsZendeskFormStagingConfig,
} from 'Config/zendeskConfig';
import type { AmendmentsAndCancellationsZendeskFormConfig } from 'Types/zendesk';
import isStaging from 'Utilities/helpers/isStaging';
import { prefixObjectKeys } from 'Utilities/helpers/object.helpers';
import { EXTERNAL_ROUTES } from 'Utilities/routes';

export const getAmendmentsAndCancellationsZendeskFormConfig = (): AmendmentsAndCancellationsZendeskFormConfig =>
	isStaging
		? AmendmentsAndCancellationsZendeskFormStagingConfig
		: AmendmentsAndCancellationsZendeskFormProductionConfig;

export const getZendeskPrePopulatedUrl = (formId: string, queryParams?: { [key: string]: string }): string => {
	const mappedParams: { [key: string]: string } = {
		ticket_form_id: formId,
		...(queryParams && prefixObjectKeys(queryParams)),
	};

	const url = new URL(EXTERNAL_ROUTES.ADJUSTMENTS_AND_CANCELLATIONS_ZENDESK);
	url.search = new URLSearchParams(mappedParams).toString();

	return url.toString();
};
